'use strict';

var RuleListingDirective = function RuleListingDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rule-listing.html'),
    controller: 'RuleListingController',
    link: function link($scope) {
      var eventMaping = {
        status: $scope.rulesStatusEventName
      };
      $scope.$on('grid:icon-click', function (event, data) {
        $scope.$broadcast(eventMaping[data.fieldId] + ':show', data);
      });
      function onMouseEnterGridIcon(event, data) {
        if (data.fieldId === 'status') {
          $scope.$broadcast($scope.statusScenarioEventName + ':show', data);
        }
      }
      $scope.$on('grid:icon-mouseenter', onMouseEnterGridIcon);
      function onMouseLiveGridIcon(event, data) {
        if (data.fieldId === 'status') {
          $scope.$broadcast($scope.statusScenarioEventName + ':hide');
        }
      }
      $scope.$on('grid:icon-mouseleave', onMouseLiveGridIcon);
      $scope.$on($scope.rulesStatusEventName + ':statusChanged', $scope.saveRuleStatus);
    }
  };
};
RuleListingDirective.$inject = [];
module.exports = RuleListingDirective;